import React from "react";

import { Icon } from "../types";

const EmploymentImpact: React.FC<Icon> = ({
  color,
  width,
  height,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 13"
    fill={color}
    {...props}
  >
    <path
      d="M7.5885 9.548C9.30825 9.15125 10.9095 8.80325 10.134 7.33925C7.7745 2.88275 9.5085 0.5 12 0.5C14.541 0.5 16.233 2.97425 13.866 7.33925C13.0673 8.81225 14.7277 9.1595 16.4115 9.548C17.901 9.89225 18 10.6205 18 11.8812L17.9977 12.5H6.00225C6.00225 10.853 5.87025 9.94475 7.5885 9.548ZM0.0015 12.5H4.50225C4.48125 7.5935 6.7485 9.72725 6.7485 5.82425C6.7485 4.3175 5.76525 3.5 4.5 3.5C2.631 3.5 1.3305 5.28725 3.1005 8.62925C3.68175 9.72725 2.48175 9.98825 1.19175 10.286C0.07425 10.544 0 11.09 0 12.0358L0.0015 12.5Z"
      fill={color}
    />
  </svg>
);
export default EmploymentImpact;
